import { render, staticRenderFns } from "./GenericDeviceData.vue?vue&type=template&id=4951d012"
import script from "./GenericDeviceData.vue?vue&type=script&lang=js"
export * from "./GenericDeviceData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports